import { Directive, ElementRef, HostBinding } from '@angular/core';
import { ImaAdService } from './ima-ad.service';

@Directive({
  selector: '[libImaAdContainer]',
  standalone: true,
})
export class ImaAdContainerDirective {
  constructor(private el: ElementRef, private ima: ImaAdService) {
    // We need to move the adContainer outside of app-root so we can have a higher z-index than the ionic.
    const adContainer = this.el.nativeElement;

    let appRoot;

    if (document.querySelector('krupion-puzzle-app-root')) {
      appRoot = document.getElementsByTagName('krupion-puzzle-app-root')[0];
    } else if (document.querySelector('krupion-puzzle-webcomponent')) {
      appRoot = document.getElementsByTagName('krupion-puzzle-webcomponent')[0];
    }

    adContainer.parentElement.removeChild(adContainer);
    appRoot.parentElement.insertBefore(adContainer, appRoot);

    // Pass the adContainer element to the service.
    ima.adContainer = this.el;
  }

  @HostBinding('style.background-color') col = 'rgba(0,0,0,1)';
  @HostBinding('style.position') position = 'absolute';
  @HostBinding('style.top') top = '0';
  @HostBinding('style.left') left = '0';
  @HostBinding('style.width') width = '100%';
  @HostBinding('style.height') height = '100%';
  @HostBinding('style.z-index') zindex = '30000';
  @HostBinding('style.display') display = 'none';
}
